import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setVerifyInputFile, setVerifyDSInputFile, clearVerifyInputFile,
		clearVerifyDSInputFile, clearVerifyResultData, clearFileSignedData } from '../../actions/localStates'
import { bindActionCreators } from 'redux'
import i18next from 'i18next'
import VerifyDSOptionsContainer from '../../containers/VerifyDSOptionsContainer'
import VerifyTextDSContainer from '../../containers/VerifyTextDSContainer'



class VerifyDSTab extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	isLoading: false
	    }

	    this.showDsVerifyResults = this.showDsVerifyResults.bind(this)
	}

	buildFileInputSelector(){
		const fileInputSelector = document.getElementById('fileInputUpload');
		return fileInputSelector;
	}

	buildFileWithDSSelector(){
		const fileWithDSSelector = document.getElementById('fileWithDSUpload');
		return fileWithDSSelector;
	}

	componentDidMount(){
    	this.fileInputSelector = this.buildFileInputSelector();
    	this.fileWithDSSelector = this.buildFileWithDSSelector();
	}

	componentDidUpdate(prevProps) {

		if (prevProps.signatureType !== this.props.defaultOptionState.signatureType) {
			this.fileInputSelector = this.buildFileInputSelector();
		}

		if (this.state.isLoading && (this.props.defaultState.verifyResults || this.props.defaultState.verifyResults === undefined)) {
			this.setState({isLoading: false})
		}
	}

	handleFileInputSelect(e) {
		e.preventDefault();
		this.fileInputSelector.value = null;
	    this.fileInputSelector.click()
	    document.activeElement.blur()
	    this.props.actions.clearVerifyResultData()
	    this.props.actions.clearFileSignedData()
	}

	handleFileWithDSSelect(e) {
	    e.preventDefault();
	    this.fileWithDSSelector.value = null;
	    this.fileWithDSSelector.click()
	    document.activeElement.blur()
	    this.props.actions.clearVerifyResultData()
	    this.props.actions.clearFileSignedData()
	}

	onChangeInput(e) {
		if (e.target.files[0] !== undefined && (e.target.files[0].size < 104857600)) {
			this.props.actions.setVerifyInputFile(e.target.files[0])
			this.props.actions.clearFileSignedData()
		}
	}

	onChangeDS(e) {
		if (e.target.files[0] !== undefined && (e.target.files[0].size < 104857600)) {
			this.props.actions.setVerifyDSInputFile(e.target.files[0])
			this.props.actions.clearFileSignedData()
		}
	}

	setInputState() {
		this.props.actions.clearVerifyResultData()
		this.setState({isLoading: true})
		this.props.setInputs()
	}

	cleanUpFileInputSelect(){
		this.props.actions.clearVerifyResultData()
		this.props.actions.clearVerifyInputFile()
		this.props.actions.clearFileSignedData()
	}

	cleanUpFileWithDSSelect(){
		this.props.actions.clearVerifyResultData()
		this.props.actions.clearVerifyDSInputFile()
		this.props.actions.clearFileSignedData()
	}

	downloadSignedData() {
		var _this = this
	    var saveBlob = (function () {
	        var a = document.createElement("a");
	        document.body.appendChild(a);
	        a.style.cssText = "display: none";
	        return function (blob, fileName) {
	        	if (navigator.appVersion.toString().indexOf('.NET') > 0) {
	        		var name = fileName.lastIndexOf(".") < 2 ? fileName : fileName.substr(0, fileName.lastIndexOf("."));
		            window.navigator.msSaveBlob(blob, name);
		            
		       } else {
		           var url = window.URL.createObjectURL(blob);
		            a.href = url;
		            a.download = fileName.lastIndexOf(".") < 2 ? fileName : fileName.substr(0, fileName.lastIndexOf("."));
		            a.click();
		            window.URL.revokeObjectURL(url);

			    }
			    window.setTimeout(function () {
			    	_this.setState({downloadIsAvailable: true})
			    }, 1000)
	        };
	    }());

	    this.setState({downloadIsAvailable: false})
	    saveBlob(this.props.defaultState.fileSignedData, this.props.defaultState.fileWithDSName);
	}

	cleanUpForm(){
		this.cleanUpFileInputSelect()
		this.cleanUpFileWithDSSelect()
		this.props.actions.clearVerifyResultData()
		this.props.actions.clearFileSignedData()
	}

	formatDate(dateInString) {
        var localeDateOptions = {
            "day": "numeric",
            "month": "numeric",
            "year": "numeric",
            "hour": "2-digit",
            "minute": "2-digit",
            "second": "2-digit",
            "timeZoneName": "short"
        }

        return new Date(dateInString).toLocaleDateString(i18next.language, localeDateOptions);
    }

    constructTimestampDetails(aTs, aTsType) {
        let contentTs = i18next.t("dataTs");
        let signatureTs = i18next.t("dsTs");
        let result = [];

        let tsTypeString = function () {
            if (aTsType === "content") {
                return contentTs;
            }
            if (aTsType === "signature") {
                return signatureTs;
            }
            return "";
        }
        
        if (aTs && aTs.dateTime) {
            if (aTs.isFailure) {
                result.push(<div>{tsTypeString() + i18next.t("ds:errorWhileVerifying")}</div>);
            } else {
            	result.push(<div>{
            		tsTypeString()
            		+ ": "
                    + (aTs.isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid"))
                    + "; "
                    + this.formatDate(aTs.dateTime)}</div>);
            }
        }
        return result;
    }

	showDsVerifyResults(verifyResults, elementToDisplay) {
		let divPtblg = [];
		

        for (var i = 0; i < verifyResults.length; i += 1) {
        	let signerNumber = [];
			let signerStatus = [];
			let signerDetails = [];
			let tsDetails = [];

			if (verifyResults[i].signatureTimestamps && verifyResults[i].signatureTimestamps.length) {
				for (var j = 0; j < verifyResults[i].signatureTimestamps.length; j += 1) {
					tsDetails.push(this.constructTimestampDetails(verifyResults[i].signatureTimestamps[j], "signature"))
				}
			}

			

        	signerNumber.push(<div className="col-2">
    			{i18next.t("ds:signature") + (i + 1)}
        	</div>)

        	if (verifyResults[i].status === "SUCCESS") {
		        signerStatus.push(<div className="col-3 text-center">
	        			{verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")}
	        		</div>)
		        signerDetails.push(<div className="col-7 signer-details">
	    			<div>
	    				{ i18next.t("ds:signer") + verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value }
	    			</div>
	    				{
							verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value ?
		                        <div>
				    				{ i18next.t("ds:drfou") + verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value }
				        		</div> : null
				        } {
				        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value ? 
					        	<div>
				    				{ i18next.t("ds:edrpou") + verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value }
				        		</div> : null
				        } {
				        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value ? 
				        		<div>
				    				{ i18next.t("ds:eddrun") + verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value }
				        		</div> : null
				        } {
				        	verifyResults[i].signerInfo.certificateSerialNumber.value ? 
		                        <div>
				    				{ i18next.t("ds:certificateSerialNumber") + verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, "") }
				        		</div> : null
	                    }
	    			<div>
	    				{ i18next.t("ds:ca") + verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value }
	        		</div>
	    			<div>
	    				{ i18next.t("ds:dsDate") + this.formatDate(verifyResults[i].signingDateTime) }
	    			</div>
	    			<div>
	    				{
	    					this.constructTimestampDetails(verifyResults[i].contentTimestamp, "content")
	    				}
	    			</div>
	    			<div>
	    				{
	    					tsDetails
		                }
	    			</div>
	    		</div>)
	        	divPtblg.push(<div className="ptblg-default"  style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
	        		<div className={verifyResults[i].isValid ? "alert alert-success" : "alert alert-warning"}>
		        		<div className="row">
		        			{signerNumber} {signerStatus} {signerDetails}
		        		</div>
		        	</div>
	        	</div>)
	        } else {
		        signerStatus.push(<div className="col-3 text-center">
	        			{i18next.t("ds:notDefined")}
	        		</div>)
		        signerDetails.push(<div className="col-7 signer-details">
		    			<div>
		    				{ verifyResults[i].failureCause }
		    				{
                                verifyResults[i].isUntrustedValid
                                ? <div><p></p><div><b>{i18next.t("ds:signatureValidWithUntrustedTime")}</b></div></div>
                                : null
                            }
		    			</div>
	    			</div>)
	        	divPtblg.push(<div className="ptblg-default" style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
	        		<div className={verifyResults[i].isValid ? "alert alert-success" : "alert alert-warning"}>
		        		<div className="row">
		        			{signerNumber} {signerStatus} {signerDetails}
		        		</div>
		        	</div>
	        	</div>)
            }
        }
        return divPtblg
    }

	render () {
		const isEnabled = this.props.defaultOptionState.signatureType === 'detached' ?
				this.props.defaultState.fileInputSelected && this.props.defaultState.fileWithDSSelected
				: this.props.defaultState.fileWithDSSelected;

		const isEnabledDownload = this.props.defaultState.fileSignedData ? true : false;

		return (
			<div>
	            <div className="row" style={{paddingTop: "10px", paddingBottom: "20px"}}>
	            <VerifyDSOptionsContainer />
	              <div className="col-8">
	                <div className="card">
	                  <div className="card-header">
	                    {i18next.t("file": "file")}
	                  </div>
	                  <div className="card-body">
	                    <div>
	                    	{
	                    		this.props.defaultOptionState.signatureType === 'detached' ? <div>
			                    	<label>{i18next.t("ds:fileForVerifyingTitle": "fileForVerifyingTitle")}</label>
			                        <div className="input-group mb-4">
										<input type="text" className="form-control" value={this.props.defaultState.fileInputName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)} readOnly />
										{
											this.props.defaultState.fileInputSelected ? <div className="input-group-append">
											      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)}>{i18next.t("changeFile": "changeFile")}</button>
											      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpFileInputSelect.bind(this)}>{i18next.t("cleanup": "cleanup")}</button>
											    </div> : <div className="input-group-append">
											    	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)}>{i18next.t("chooseFile": "chooseFile")}</button>
											    </div>
										}
										<input id="fileInputUpload" type="file" onChange={this.onChangeInput.bind(this)} style={{"display": "none"}} />
									</div>
								</div> : <input id="fileInputUpload" type="file" onChange={this.onChangeInput.bind(this)} style={{"display": "none"}} />
	                    	}


							<label>{i18next.t("ds:fileWithDsTitle": "fileWithDsTitle")}</label>
	                        <div className="input-group mb-4">
								<input type="text" className="form-control" value={this.props.defaultState.fileWithDSName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)} readOnly />
								{
									this.props.defaultState.fileWithDSSelected ? <div className="input-group-append">
									      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)}>{i18next.t("changeFile": "changeFile")}</button>
									      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpFileWithDSSelect.bind(this)}>{i18next.t("cleanup": "cleanup")}</button>
									    </div> : <div className="input-group-append">
									    	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)}>{i18next.t("chooseFile": "chooseFile")}</button>
									    </div>
								}
								<input id="fileWithDSUpload" type="file" onChange={this.onChangeDS.bind(this)} style={{"display": "none"}} />
							</div>

							{
								this.props.defaultState.verifyResults ? this.showDsVerifyResults(this.props.defaultState.verifyResults, this.props.defaultState.divId)
									: null
							}

	                        <button className="btn btn-default" onClick={this.setInputState.bind(this)} disabled={!isEnabled}>{i18next.t("ds:verifyDs": "verifyDs")}
	                        	{
	                              	this.state.isLoading ? <span>&nbsp;<i className="fa fa-spinner fa-pulse"></i></span>
	                                : null
	                            }
	                        </button>
	                        {
	                        	this.props.defaultOptionState.signatureType === 'attached'
	                        	? <button className="btn btn-default" disabled={!isEnabledDownload} style={{marginLeft: "7px"}} onClick={this.downloadSignedData.bind(this)}>{i18next.t("ds:saveSignedData": "saveSignedData")}</button>
	                        	: null
	                        }
	                        <button className="btn btn-default" style={{marginLeft: "7px"}} onClick={this.cleanUpForm.bind(this)}>{i18next.t("cleanUpForm": "cleanUpForm")}</button>
	                    </div>
	                    </div>
	                   </div>
	                   &nbsp;
	                   <VerifyTextDSContainer />
	                </div>
	            </div>
	        </div>
		);
	}
}

function mapStateToProps(state) {
    return {
        language: state.localesReducer.language,
        localesReducer: state.localesReducer,
        defaultState: state.verifyDSInputReducer,
        defaultOptionState: state.verifyDSOptionsReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
    	setVerifyInputFile,
    	setVerifyDSInputFile,
    	clearVerifyInputFile,
    	clearVerifyDSInputFile,
    	clearVerifyResultData,
    	clearFileSignedData
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyDSTab);


// WEBPACK FOOTER //
// ./src/components/body/VerifyDSTab.js